<template>
  <td colspan="12" style="background: #f6f6f6; text-align: center" class="pa-0">
    <div class="table-expanded">
      <div class="my-4 table-expanded__content">
        <ListInventoryExpand
          type="mass"
          :model="model"
          displayType="show"
          @openListImeiDialog="openListImeiDialog"
          :descriptionColumn="descriptionColumn"
        />
      </div>
    </div>
    <dialog-list-imei ref="dialog-list-imei" />
  </td>
</template>
<script>
import DialogListImei from './DialogListImei.vue'
import ListInventoryExpand from './ListInventoryExpand.vue'
export default {
  components: { ListInventoryExpand, DialogListImei },
  props: {
    model: Object,
    descriptionColumn: {
      type: Number,
      default: null
    }
  },
  name: 'TableExpandReportOnTime',
  methods: {
    openListImeiDialog(inventoryId) {
      this.$refs['dialog-list-imei'].openDialog({ model: this.model, inventoryId })
    }
  }
}
</script>
<style lang="scss" scoped>
.table-expanded {
  width: calc(100% - 150px);
  margin-left: 150px;
}
</style>
